<template>
  <div>
    <div class="c-header c-bg">
      <div class="user">
        <img src="@/assets/img/user.png"/>
        <div class="user-info">
          <h3>{{name}} <van-icon name="bianji1"></van-icon></h3>
          <p>女士  <span>|</span>  工作10年  <span>|</span>  上海嘉定</p>
        </div>
      </div>
      <ul class="links">
        <li><van-icon name="shouji"></van-icon><span>14258207239</span></li>
        <li><van-icon name="youxiang"></van-icon><span>13094914028@163.com</span></li>
      </ul>
    </div>
    <ul class="resume">
      <li>
        <div class="resume-header">
          <h3>求职意向</h3>
          <van-icon name="bianji1"></van-icon>
        </div>
        <div class="resume-body">
          <div class="job-wanted">
            <div class="wanted-header">
              <h4>求职状态：</h4>
              <span>离职-随时到岗</span>
            </div>
            <ul class="wanted-list">
              <li>
                <van-icon name="zhiyeweisheng1"></van-icon>
                <div class="w-detail">
                  <h5>普工</h5>
                  <span>5000-8000元·全嘉定·行业不限·全职</span>
                </div>
              </li>
              <li>
                <van-icon name="zhiyeweisheng1"></van-icon>
                <div class="w-detail">
                  <h5>普工</h5>
                  <span>5000-8000元·全嘉定·行业不限·全职</span>
                </div>
              </li>
              <li>
                <van-icon name="zhiyeweisheng1"></van-icon>
                <div class="w-detail">
                  <h5>普工</h5>
                  <span>5000-8000元·全嘉定·行业不限·全职</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>自我介绍</h3>
          <van-icon name="bianji1"></van-icon>
        </div>
        <div class="resume-body">
          <p class="about">
            本人诚实守信，乐观开朗，沟通潜力强，肯学习，学习和动手潜力强，吃苦耐劳，用心向上，稳重踏实，职责心强，有主见，组织管理潜力好，团体意识强，能协助他人并自己独立…
          </p>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>工作经历</h3>
          <van-icon name="tianjia"></van-icon>
        </div>
        <div class="resume-body">
          <div class="history-list">
            <div class="hist-header">
              <h4><van-icon name="gongsi"></van-icon> 上海中讯志远科技有限公司</h4>
              <van-icon name="bianji1"></van-icon>
            </div>
            <div class="time">2017.01-2020.03</div>
            <div class="h-name">
              <span>线上销售业务员</span>
              <span>8000元/月</span>
            </div>
            <ul class="label">
              <li>综合维修</li>
            </ul>
            <p>今年以来，XXXX五个科室围绕安全生产精心组织，齐心协力，做了大量周密细致的工作。XXXX结合今年工作任务…</p>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>教育经历</h3>
          <van-icon name="tianjia"></van-icon>
        </div>
        <div class="resume-body">
          <div class="history-list">
            <div class="hist-header">
              <h4><van-icon name="shu"></van-icon> 上海复旦大学</h4>
              <van-icon name="bianji1"></van-icon>
            </div>
            <div class="time">2012.09-2016.06</div>
            <div class="h-name">
              <span>本科 计算机信息管理</span>
            </div>
            <ul class="label">
              <li>统招</li>
              <li>有学位证书</li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="resume-header">
          <h3>获得证书</h3>
          <van-icon name="tianjia"></van-icon>
        </div>
        <div class="resume-body">
          <div class="history-list">
            <div class="hist-header">
              <h4><van-icon name="zhengshu"></van-icon> 计算机专业4级</h4>
              <van-icon name="bianji1"></van-icon>
            </div>
            <div class="time">2016.06</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'myResume',
  data() {
    return {
      name: '豆瑗维'
    }
  }
}
</script>

<style lang="less" scoped>
  .c-header .user .user-info h3{
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    i{
      font-size: 16px;
      margin-left: 14px;
    }
  }
  .c-header .user img{
    width: 88px;
    height: 88px;
  }
  .user{
    flex-direction: row-reverse;
    margin-left: 0;
    margin-right: 20px;
  }
  .c-header .user .user-info:after{
    display: none;
  }
  .links{
    margin:20px;
    li{
      color:#fff;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 6px;
      }
      i{
        width: 30px;
      }
    }
  }

</style>
